export default __webpack_public_path__ + "static/media/080_finish_soso.first.c1ff2fd9.webp";